import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { CustomEventService } from '@shared/services/custom-event.service';
import { validateFormGroup } from '@shared/utils/form.util';
import { Router } from "@angular/router";
import { NzNotificationService } from "ng-zorro-antd/notification";

@Component({
  selector: 'app-import-user-ldap',
  templateUrl: './import-user-ldap.component.html'
})
export class ImportUserLdapComponent {
  loading: boolean;

  @Input() type: string;
  userList: any[] = [];
  searchUserForm: FormGroup;
  selectUserForm: FormGroup;

  constructor(private customEventService: CustomEventService,
              private fb: FormBuilder,
              private router: Router,
              private notificationService: NzNotificationService,) {
    this.searchUserForm = this.fb.group({
      searchText: [null, [Validators.required]]
    });
    this.selectUserForm = this.fb.group({
      selectedUser: [null, [Validators.required]]
    });
  }

  search(): void {
    validateFormGroup(this.searchUserForm);

    if (this.searchUserForm.invalid) {
      return;
    }

    this.type === 'ldap' ? this.customEventService.announceEvent(ActionTypesEnum.LDAP_SEARCH_CHANGE, this.searchUserForm.value.searchText)
      : this.customEventService.announceEvent(ActionTypesEnum.AZURE_SEARCH_CHANGE, this.searchUserForm.value.searchText);
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  submitForm(): void {
    validateFormGroup(this.selectUserForm);

    if (this.selectUserForm.invalid) {
      return;
    }

    const { selectedUser } = this.selectUserForm.value;

    this.type === 'ldap' ? this.customEventService.announceEvent(ActionTypesEnum.IMPORT_FROM_LDAP, selectedUser)
      : this.customEventService.announceEvent(ActionTypesEnum.IMPORT_FROM_AZURE, selectedUser)
    this.notificationService.success('Added successfully.', null);
  }
}
